<template>
  <v-app>
    <v-app-bar color="rgba(0,0,0,0)" flat absolute dark>
      <v-toolbar-title>
        <v-btn to="/" icon v-if="$route.name !== 'home'">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-btn tile text v-else> {{ networkFullName }} Banpanel </v-btn>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
        :href="networkUrl"
        target="_blank"
        no-refferral
        text
        class="d-none d-sm-flex"
      >
        <span class="mr-2"> Go to {{ networkFullName }}</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
    <v-footer app>
      <v-row justify="space-between" no-gutters dense>
        <v-btn text small tile href="https://orbiter.digital/"
          >by Orbiter</v-btn
        >
        <v-switch
          v-model="$vuetify.theme.dark"
          hide-details
          inset
          flat
          dense
          class="ma-0"
          label="Dark theme"
          @change="handleThemeChange"
        >
          <template v-slot:label>
            <span class="overline">Dark theme</span>
          </template>
        </v-switch>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import config from "@/config.js";

export default {
  name: "App",

  data: () => ({
    networkFullName: config.networkFullName
  }),
  methods: {
    handleThemeChange(isDark) {
      localStorage.setItem("darkTheme", isDark);
    }
  },
  computed: {
    networkUrl() {
      switch (config.networkName) {
        case "sky":
          return "https://cosmicsky.com/";
        case "prisons":
          return "https://cosmicprisons.com/";
        default:
          return "https://cosmic.games/projects/";
      }
    }
  },
  created() {
    if (localStorage.getItem("darkTheme") === "true") {
      this.$vuetify.theme.dark = true;
    }
  }
};
</script>
